/**
 * Every deployment-level feature switch, in one place.
 *
 * Each flag reads a REACT_APP_* variable from .env (or the host's environment) and is ON only when
 * the variable is exactly "1". CRA inlines these at build time, so restart `npm run dev` or rebuild
 * after changing one. To add a switch: add a line here, a line to .env, and use FEATURE_FLAGS.<name>.
 */
/* eslint-disable no-undef */
const isOn = (value) => value === "1";

const FEATURE_FLAGS = {
    // Add-ons item in the sidebar and the add-ons pages.
    addons: isOn(process.env.REACT_APP_ADDONS_ENABLED),
    // INSHUR card under Settings > Integration > Insurance.
    inshur: isOn(process.env.REACT_APP_INSHUR_ENABLED),
    // Sola gateway under Settings > Integration > Payment.
    sola: isOn(process.env.REACT_APP_SOLA_ENABLED),
    // TeqMobility Full Coverage: the company-level coverage switch and the Full Coverage option in
    // the insurance add-on forms. Off keeps everything on Liability.
    teqFullCoverage: isOn(process.env.REACT_APP_TEQ_FULL_COVERAGE_ENABLED),
};

export default FEATURE_FLAGS;
